import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListTokenAuthIdCell } from './transaction-list-token-auth-id.cell';
import { TransactionListTokenAuthIdHeader } from './transaction-list-token-auth-id.header';

export const TransactionListTokenAuthIdColumn: IdentifiedColumnDef<
  TransactionModel,
  NonNullable<TransactionModel['token']>['authId'] | undefined
> = {
  id: 'tokenAuthId',
  enableSorting: false,
  header: TransactionListTokenAuthIdHeader,
  cell: TransactionListTokenAuthIdCell,
  meta: { maxWidth: '90px', width: '80px', minWidth: '60px' },
};
